@if ({
  countriesOptions: (countriesOptions$ | async) ?? [],
  priceCountryData: (priceCountry$ | async) ?? priceCountryDataDefault,
  hasData: hasData
  }; as vm) {
  <div class="price-tiers-new p-4">
    <div class="page-heading mb-4 flex items-center justify-between">
      <div class="flex gap-4">
        <h3>Edit Pricing Country</h3>
      </div>
    </div>
    <!-- {{ vm.priceCountryData|json }} -->
    @if (!vm.hasData) {
      <div class="text-center">Loading...</div>
    }
    @if (vm.hasData) {
      <div class="tier-form">
        <div class="card rounded-lg border border-neutral-100 px-6 py-9">
          @if (vm.priceCountryData && vm.countriesOptions.length > 0) {
            <app-form-price-country
              (submitEvent)="onSubmit($event)" [model]="vm.priceCountryData" [countries]="vm.countriesOptions">
            </app-form-price-country>
          }
        </div>
      </div>
    }
  </div>
}